module.exports = __webpack_public_path__ + "media/hyper/fonts/Nunito-Light-bebe3f7d34a2d8b52942a7b148f2c2b0.ttf";